import { post } from 'axios';


export const getPurchaseAppData = (url, domain_id, cartData, discountCode = '') => {
    return post(url, {
        headers: {'Content-Type': 'application/json'},
        data: {
            domain_id: domain_id,
            product_quantities: {...cartData},
            discount_code: discountCode
        }
    })
}
export const addItemToCartGA = (item) => {
    if(typeof window !== "undefined" && window.dataLayer && item) {
    window.dataLayer.push({
        event: "add_item",
        ecommerce: {
            currency: "USD",
            value:item.unit_cost,
            items: [
                {
                    title: item.title,
                    brand_name: item.brand_name || 'mindedge',
                    product_type: (item.course_id.includes('suite')? 'suite': 'course'),
                    category: item.category || 'none provided',
                    list_price: item.unit_cost,
                }
            ]
        }
    });
}
}

//Transforms PA response into data model for <ShoppingCartItem> component
export const transformPAData = (cartData, purchaseAppData) => {
    //get array of product id's
    let itemIds = Object.keys(cartData);
    //Transform each item into an item object for <ShoppingCartItem> component
    return itemIds.map((item) => {
        let itemObj = {
            course_id: item,
            category: purchaseAppData.categories[item],
            title: purchaseAppData.titles[item],
            quantity: purchaseAppData.quantities[item],
            unit_cost: purchaseAppData.unit_costs[item],
            unit_total: (purchaseAppData.quantities[item] * purchaseAppData.unit_costs[item]),
        };
        addItemToCartGA(itemObj)
        return itemObj;
    });
}